import React from 'react'

import RentalListItem from './RentalListItem'
import listStyles from './listStyles'

export default function RentalListItems({
  appProps, rentals, rentalListVersion, itemsPerRowClass, itemsPerRow,
  filtersDates, parentId, loading
}) {

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: parentId ? `#${ parentId } { ${ listStyles(appProps, itemsPerRow) }}` : listStyles(appProps) }}/>

      <div className='rental-list'>
        <div className='rental-list-items'>
          { rentals.length > 0 && rentals.map( rental => (
            <a
              key={ rental.id }
              href={ `${ filtersDates ? rental.link + '?' + filtersDates : rental.link }` }
              className={ `${ rentalListVersion } rental-item ${ itemsPerRowClass || '' }` }
            >
              <RentalListItem
                appProps={ appProps }
                rental={ rental }
                rentalListVersion={ rentalListVersion }
              />
            </a>
          ))}

          { rentals.length === 0 && !loading && appProps.translations.rentals.no_rentals_found }
        </div>
      </div>
    </>
  )
}
